import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import './FlexibleNavbar.css'
import React from 'react';
import Utils from '../utils'

class FlexibleNavbar extends React.Component {

  constructor(props) {
    super(props);
    
    this.menu_elements = [
      {
        'id_section': '#home',
        'id_menu_item': '#home-button'
      },
      {
        'id_section': '#projects',
        'id_menu_item': '#projects-button'
      },
      {
        'id_section': '#about',
        'id_menu_item': '#about-button'
      },
      {
        'id_section': '#contacts',
        'id_menu_item': '#contacts-button'
      }
    ];
  }

  componentDidMount() {
    this.isMobile = this.checkIsMobile();
    window.addEventListener('scroll', this.handleScroll, true);
    window.addEventListener('resize', this.handleResize, true);
    setInterval(this.tick, 100);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  checkIsMobile = function () {
    let check = false;
    // eslint-disable-next-line
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };



  checkScreenTooTight = () => {
    return (window.innerWidth <= 800);
  };

  tick = () => {

    this.handleForActiveElements();

    if (this.isMobile) return;

    this.updateMarginMainContent();

  };

  handleResize = () => {


    this.handleMenuChange();

  };

  handleScroll = () => {

    this.handleMenuChange();

  };

  updateMarginMainContent = (margin_input = -1) => {

    let margin = document.getElementById('flexible-navbar').offsetWidth;
    if (margin > 150) margin = 0;

    let element = document.getElementsByClassName('main-content-container');
    if (element === undefined || element.length !== 1) return;
    element = element[0];

    element.style.marginRight = margin + "px";
  }

  handleForActiveElements = () => {
    const elements = this.menu_elements;


    elements.forEach(element => {
      let section = document.querySelector(element.id_section);


      if (section === undefined || section === null) return;

      let items_to_be_active = document.querySelectorAll(element.id_menu_item);
      if (items_to_be_active === undefined || items_to_be_active.length === 0) return;


      items_to_be_active.forEach(item => {

        if (section.getBoundingClientRect().top <= 90 && section.getBoundingClientRect().bottom >= 90) {
          Utils.addClass(item, 'active');
        } else {
          Utils.removeClass(item, 'active');
        }
      });

    });
  }


  handleMenuChange = () => {

    if (this.isMobile) return;

    if (this.checkScreenTooTight()) {
      Utils.removeClass(document.getElementById("flexible-navbar"), 'flexible-navbar-vertical');
      return;
    }

    let scroll = window.scrollY;
    let headerContent = document.getElementById('HeaderContent');

    let heightOfHeaderContent = headerContent.offsetHeight;

    let topOfHeaderContent = document.body.getBoundingClientRect().top - headerContent.getBoundingClientRect().top;

    var navbarItem = document.getElementById("flexible-navbar");

    // Sono sotto la metà del blocco sull'header
    if ((scroll - topOfHeaderContent) > (heightOfHeaderContent / 2)) {


      // Se non è stato animato per metterlo in verticale
      if (!navbarItem.classList.contains("flexible-navbar-vertical")) {

        Utils.addClass(navbarItem, 'fade-out');

        setTimeout(() => {
          Utils.removeClass(document.getElementById('home-button'), 'hide-on-homepage');

          Utils.removeClass(navbarItem, 'fade-out');
          Utils.addClass(navbarItem, 'fade-in');
          Utils.addClass(navbarItem, 'flexible-navbar-vertical');

          setTimeout(() => {
            Utils.removeClass(navbarItem, 'fade-in');
          }, 400);

        }, 400);

      }

    } else {


      // Se non è stato animato per metterlo in orizzontale
      if (navbarItem.classList.contains("flexible-navbar-vertical")) {

        Utils.addClass(navbarItem, 'fade-out');

        setTimeout(() => {
          Utils.addClass(document.getElementById('home-button'), 'hide-on-homepage');

          Utils.removeClass(navbarItem, 'fade-out');
          Utils.removeClass(navbarItem, 'flexible-navbar-vertical');
          Utils.addClass(navbarItem, 'fade-in');

          setTimeout(() => {
            Utils.removeClass(navbarItem, 'fade-in');
          }, 400);

        }, 400);
      }
    }

  };


  render() {

    let homeButton;

    if (this.isMobile){

      homeButton = (
        <a id="home-button" className="flexible-item" href="#home" >
          <div className="flexible-item-icon" >
            <HomeRoundedIcon />
          </div>
          <div className="flexible-item-text" >
            Home
          </div>
        </a>
      );

    }else{
      
      homeButton = (
        <a id="home-button" className="flexible-item hide-on-homepage" href="#home" >
          <div className="flexible-item-icon" >
            <HomeRoundedIcon />
          </div>
          <div className="flexible-item-text" >
            Home
          </div>
        </a>
      );

    }

    let projectsButton = (
      <a id="projects-button" className="flexible-item" href="#projects" >
        <div className="flexible-item-icon" >
          <AccountTreeRoundedIcon />
        </div>
        <div className="flexible-item-text" >
          Projects
        </div>
      </a>
    );

    let aboutButton = (
      <a id="about-button" className="flexible-item" href="#about" >
        <div className="flexible-item-icon" >
          <ConnectWithoutContactIcon />
        </div>
        <div className="flexible-item-text" >
          Let's connect!
        </div>
      </a>
    );
    /*
	let contactsButton = (
      <a id="contacts-button" className="flexible-item" href="#contacts" >
        <div className="flexible-item-icon" >
          <ContactPhoneRoundedIcon />
        </div>
        <div className="flexible-item-text" >
          Contacts
        </div>
      </a>
    );
	*/

    return (
      <div id="flexible-navbar" className="flexible-navbar">

        {homeButton}

        {projectsButton}

        {aboutButton}        

        

      </div>
    )
  }
}


export default FlexibleNavbar;